// @ts-nocheck
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import {
    getComputedVariantProduct as baseGetComputedVariantProduct,
    getProductState,
    getProductStateByPath,
} from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { CartLineModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import getBooleanProperty from "@toolkit/Framework/Common/Utilities/getBooleanProperty";

export const getComputedVariantProduct = (
    parentProductState: ReturnType<typeof getProductStateByPath>,
    variantProductState: ReturnType<typeof getProductState>,
) => {
    const productDataView = baseGetComputedVariantProduct(parentProductState, variantProductState);

    if (productDataView === parentProductState) {
        return productDataView;
    }

    const { value: variantProduct } = variantProductState;

    ["productTitle", "detail", "content", "documents", "specifications", "attributes", "attributeTypes"].forEach(x => {
        const variantValue = (variantProduct as any)?.[x];
        if (variantValue) {
            (productDataView as any).value[x] = variantValue;
        }
    });

    return productDataView;
};

export const productHasPrice = (product: ProductInfo | CartLineModel | undefined) => {
    if (!product) {
        return;
    }

    if ("properties" in product && product.properties?.hasPrice) {
        return getBooleanProperty((product as any)?.properties?.hasPrice);
    }

    if ("pricing" in product) {
        return getBooleanProperty(product?.pricing?.additionalResults?.hasPrice);
    }
};
